module.exports = __webpack_public_path__ + "static/media/badge_level_3_3.1eaceeaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_3_3.png
// module id = 515
// module chunks = 0